import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import cx from 'classnames';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import InputSelect from '../ui/inputSelect';
import SearchBar from '../ui/searchBar';
import EIRDetail from './EIR-detail'; // api

import { getLogsLogisticsAll } from '../../api/statsAPI'; // redux

import { setLogsLogisticsList, setLogisticTotal, setLogisticId, setLogisticKeyword, setLogisticCurrentPage, setLogisticRowsPerPage, setLogisticSort } from '../../redux/logistic-deliver';
var t = i18n.getFixedT(null, 'logistic-deliver');
var gt = i18n.getFixedT(null, 'app');

var DeliverLog = function DeliverLog() {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      logisticsList = _useSelector.app.logisticsList,
      _useSelector$logistic = _useSelector.logisticDeliver,
      dateTime = _useSelector$logistic.dateTime,
      logsLogisticsList = _useSelector$logistic.logsLogisticsList,
      logisticSort = _useSelector$logistic.logisticSort,
      logisticId = _useSelector$logistic.logisticId,
      logisticKeyword = _useSelector$logistic.logisticKeyword,
      logisticCurrentPage = _useSelector$logistic.logisticCurrentPage,
      logisticRowsPerPage = _useSelector$logistic.logisticRowsPerPage,
      logisticTotal = _useSelector$logistic.logisticTotal;

  var dispatch = useDispatch();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialogEIRData = _useState2[0],
      setDialogEIRData = _useState2[1];

  var isMounted = useRef(false);

  var handleChangeInputSelect = function handleChangeInputSelect(item) {
    if (_.isEmpty(item)) return;
    if (item === 'all' || item.value === 'all') return dispatch(setLogisticId(''));
    dispatch(setLogisticId(item.value));
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    dispatch(setLogisticCurrentPage(newPage));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    dispatch(setLogisticRowsPerPage(parseInt(e.target.value, 10)));
    dispatch(setLogisticCurrentPage(0));
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return '';
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var handleSort = function handleSort(sort) {
    dispatch(setLogisticSort(sort));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    var offset = (Number(logisticCurrentPage + 1) - 1) * logisticRowsPerPage;
    getLogsLogisticsAll(contextRoot, false, logisticId, logisticKeyword, dateTime, logisticSort, offset, logisticRowsPerPage).then(function (result) {
      var newData = _.map(result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      dispatch(setLogsLogisticsList(newData));
      if (!_.isEqual(logisticTotal, result.totalElements)) dispatch(setLogisticTotal(result.totalElements));
    });
  }, [JSON.stringify(logisticSort), logisticKeyword, logisticCurrentPage, logisticRowsPerPage, logisticId]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'deliverType', {
    label: t('lbl-deliver-types'),
    sortable: true,
    formatter: function formatter(val, row) {
      return val ? t('lbl-' + val.toUpperCase()) : '';
    }
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailer-plate-no'),
    sortable: true
  });

  _.set(fields, 'transportType', {
    label: t('lbl-transport-type'),
    sortable: true
  });

  _.set(fields, 'containerType', {
    label: t('lbl-container-type'),
    sortable: true
  });

  _.set(fields, 'containerNo', {
    label: t('lbl-container-number'),
    sortable: true
  });

  _.set(fields, 'oriTerminalName', {
    label: t('lbl-ori-terminal'),
    sortable: true
  });

  _.set(fields, 'dstTerminalName', {
    label: t('lbl-dst-terminal'),
    sortable: true
  });

  _.set(fields, 'driverName', {
    label: t('lbl-driver-name'),
    sortable: true
  });

  _.set(fields, 'logisticName', {
    label: t('lbl-logistic'),
    sortable: true
  });

  _.set(fields, 'estBeginTime', {
    label: t('lbl-est-begin-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'oriZoneOutTime', {
    label: t('lbl-ori-zone-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstZoneInTime', {
    label: t('lbl-dst-zone-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalInTime', {
    label: t('lbl-dst-terminal-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalOutTime', {
    label: t('lbl-dst-terminal-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'finishTime', {
    label: t('lbl-dst-zone-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'hasEir', {
    label: t('lbl-has-eir'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: cx({
          'disable': !val
        }),
        title: t('lbl-has-eir')
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          if (!val) return;
          setDialogEIRData(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-list-alt"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "deliverLog-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-deliver-log')), /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-logistic'), ": "), /*#__PURE__*/React.createElement(InputSelect, {
    className: "inputSelect",
    options: logisticsList,
    onChange: handleChangeInputSelect
  })), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      dispatch(setLogisticKeyword(search));
    },
    value: logisticKeyword
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    enableTextWordWrap: true,
    fields: fields,
    data: logsLogisticsList,
    sort: logisticSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: logisticTotal,
    page: logisticCurrentPage,
    onChangePage: handleChangePage,
    rowsPerPage: logisticRowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), !_.isEmpty(dialogEIRData) && /*#__PURE__*/React.createElement(EIRDetail, {
    data: dialogEIRData,
    onClose: function onClose() {
      return setDialogEIRData(null);
    }
  }));
};

export default DeliverLog;